import { FaFacebookF, FaTwitter, FaYoutube, FaInstagram } from "react-icons/fa";
import { HiLocationMarker, HiPhone, HiMail } from "react-icons/hi";

const Footer = () => {
  return (
    <footer className="bg-[#0F2C3E] text-white py-10">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 px-6">
        
        {/* Logo & Description */}
        <div>
          <h2 className="text-2xl font-bold">Shri Radha Krishna Mandir</h2>
          <p className="mt-3 text-gray-300">
            A spiritual sanctuary offering divine blessings and astrological guidance in Sitabuldi, Nagpur.
          </p>
          <div className="flex space-x-3 mt-4">
            <a href="https://www.facebook.com/share/16FfVCno2r/" className="text-white bg-purple-500 p-2 rounded-full"><FaFacebookF /></a>
            <a href="#" className="text-white bg-purple-500 p-2 rounded-full"><FaTwitter /></a>
            <a href="#" className="text-white bg-purple-500 p-2 rounded-full"><FaYoutube /></a>
            <a href="#" className="text-white bg-purple-500 p-2 rounded-full"><FaInstagram /></a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-xl font-bold mb-3">Quick Links</h3>
          <ul className="space-y-2">
            <li><a href="/" className="text-gray-300 hover:text-white">Home</a></li>
            <li><a href="/about" className="text-gray-300 hover:text-white">About Us</a></li>
            <li><a href="/portfolio" className="text-gray-300 hover:text-white">Portfolio</a></li>
            {/* <li><a href="#" className="text-gray-300 hover:text-white">Services</a></li> */}
            <li><a href="/contact" className="text-gray-300 hover:text-white">Contact</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-xl font-bold mb-3">Contact Info</h3>
          <p className="text-gray-300 flex items-center"><HiLocationMarker className="mr-2" /> Sitabuldi, Nagpur, India</p>
          <p className="text-gray-300 flex items-center"><HiPhone className="mr-2" /> <a href="https://wa.me/918087577777" target="_blank" rel="noopener noreferrer"> +91 8087577777 </a></p>
          <p className="text-gray-300 flex items-center"><HiMail className="mr-2" /> <a href="mailto:radheradhenagpur@gmail.com">  radheradhenagpur@gmail.com </a></p>
        </div>

        {/* Newsletter */}
        <div>
          <h3 className="text-xl font-bold mb-3">Newsletter</h3>
          <p className="text-gray-300">Subscribe to receive temple updates and spiritual insights.</p>
          <div className="mt-4 flex">
            <input type="email" placeholder="Email Address" className="w-full p-2 rounded-l-lg text-black" />
            <button className="bg-purple-500 text-white px-4 py-2 rounded-r-lg"><HiMail /></button>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
